<dx-popup
  title="{{ titleLabel }}"
  deferRendering="true"
  contentTemplate="content"
  height="auto"
  [maxHeight]="'97%'"
  [width]="popUpWith"
  hideOnOutsideClick="true"
  [visible]="showPopup"
  (onHiding)="onHide()"
  [shading]="true"
>
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="form">
      <div *ngIf="workshop">
        <h5 class="text-success">
          <ng-icon name="lucideSquare" class="text-warning"></ng-icon>
          {{ workshop?.title }}
        </h5>
        <div class="mt-2">
          {{ workshop?.holdingDateJalali }} | {{ workshop?.holdingTypeTitle }}
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <label class="form-label">{{ attendanceTypeLabel }}</label>
            <dx-select-box
              [items]="workshop?.holdingType"
              displayExpr="title"
              valueExpr="id"
              formControlName="attendanceTypeId"
            ></dx-select-box>
          </div>
          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <label class="form-label">{{ informWayLabel }}</label>
            <dx-select-box
              [items]="informWays"
              displayExpr="title"
              valueExpr="id"
              formControlName="informWayId"
            ></dx-select-box>
          </div>
          <div class="col-12 mt-3" *ngIf="workshop?.hasQuestionBox">
            <label class="form-label">{{ questionsLabel }}</label>
            <dx-text-area
              formControlName="questions"
              [height]="'130px'"
            ></dx-text-area>
          </div>
        </div>
        <div class="mt-3 lh-lg">
          <dx-check-box
            rtlEnabled="true"
            formControlName="confirmed"
          ></dx-check-box>
          <span class="ms-2">{{ registerPromptLabel }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4 pb-4">
        <button
          class="btn btn-success d-flex align-items-center"
          (click)="onRegister()"
          [disabled]="!form?.valid"
        >
          <span class="fa fa-check me-1"></span>
          {{ registerLabel }}
        </button>
      </div>
    </form>
  </div>
</dx-popup>
